<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center gap-5">
                    <h2 class="mb-0">Digital Waivers</h2>
                </div>
                <button mat-raised-button (click)="createWaiver()">
                    Add <mat-icon>add</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
                [filter]="filter" [data]="waivers" (filterChanged)="getWaivers()" (filterReset)="resetFilter()">
            </gt-table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <table mat-table [dataSource]="waivers" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="title">Title</th>
                    <td mat-cell *matCellDef="let waiver"> {{waiver.title}} </td>
                </ng-container>
                <ng-container matColumnDef="isActive">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="isActive">Active</th>
                    <td mat-cell *matCellDef="let waiver">
                        <section>
                            <mat-slide-toggle
                                [checked]="waiver.isActive"
                                (change)="updateIsActive(waiver, $event.checked)">
                                <ng-container *ngIf="waiver.isActive">Yes</ng-container>
                                <ng-container *ngIf="!waiver.isActive">No</ng-container>
                            </mat-slide-toggle>
                        </section>
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastEditedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="lastEditedDate">Last Edited Date</th>
                    <td mat-cell *matCellDef="let waiver"> {{waiver.lastEditedDate | date: 'MMM d, y, h:mm a'}} </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let waiver">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionsMenu>
                            <button mat-menu-item (click)="edit(waiver)">
                                Edit <mat-icon>edit</mat-icon>
                            </button>&nbsp;
                            <button mat-menu-item (click)="delete(waiver)">
                                Delete <mat-icon>delete</mat-icon>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>
